import { render, staticRenderFns } from "./write-off-list.vue?vue&type=template&id=8b0c6f82&"
import script from "./write-off-list.vue?vue&type=script&lang=js&"
export * from "./write-off-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports